import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { IAppError } from "@comunicare/comunicare-interfaces";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { FileLogger } from "../error-handling/fileLogger";

export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "";
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = error.error.message;
        } else {
          // server-side error
          errorMessage = error.message;
        }
        FileLogger.warn("HttpErrorInterceptor", "intercept " + error.status, errorMessage, "none");
        // The API's error envelope ({ success: false, message, data: "<CODE>" }), when there is one: lets a
        // caller choose its message from the error code rather than from the HTTP status alone.
        const serverCode = typeof error.error?.data === "string" ? error.error.data : undefined;
        return throwError({
          global: true,
          code: error.status,
          message: errorMessage,
          ...(serverCode ? { additionalData: serverCode } : {}),
        } as IAppError);
      })
    );
  }
}
